import React from "react";
import { Modal } from "@mantine/core";

import ModalHeader from "components/ModalHeader";
import UpdateOrgForm from "./updateOrgForm";
// import UpdateOrgForm from "./updateOrgForm";
// import AddHolidayForm from "./addHolidayForm";

type UpdateModalProps = {
  opened: boolean;
  orgId: string;
  onClose: () => void;
};

function UpdateOrgModal({ opened, onClose, orgId }: UpdateModalProps) {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      overlayOpacity={0.5}
      size="lg"
      shadow="xs"
      withCloseButton={false}
      transitionDuration={300}
      centered
    >
      <ModalHeader
        title="Update Your Organization"
        onClose={onClose}
        ariaLabel="Close add Holiday modal"
      />
      <UpdateOrgForm orgId={orgId} onClose={onClose} />
    </Modal>
  );
}

export default UpdateOrgModal;
